module.exports = __webpack_public_path__ + "assets/img/Blue-Microphones-Landing-Page-w540.367d77c2.jpg";